export const enServices = {
  services: {
    our:"OUR",
    title: "SERVICES",
    subTitle:"BOOST YOUR BUSINESS WITH OUR DIGITAL EXPERTISE!",
    description: "Ganesh Coding Office delivers innovative digital services, from web and mobile development to cloud, DevOps, and cybersecurity, empowering businesses to grow with confidence.",
    verticals: {
      webDevelopment: {
        title: "Website Development",
        description: "Custom-built responsive websites with modern frameworks, optimized for performance, security, and search engine visibility."
      },
      mobileApp: {
        title: "Mobile App Development",
        description: "Native and cross-platform mobile applications with intuitive UX/UI design, offline capabilities, and seamless backend integration."
      },
      digitalTransformation: {
        title: "Digital Transformation Consulting",
        description: "End-to-end digital strategy consulting to modernize operations, automate processes, and enhance customer experiences."
      },
      seo: {
        title: "SEO Optimization",
        description: "Data-driven SEO strategies including technical audits, content optimization, and link building to maximize organic growth."
      },
      socialMedia: {
        title: "Social Media Marketing",
        description: "Strategic social media management with content creation, paid advertising, influencer partnerships, and performance tracking."
      },
      graphicDesign: {
        title: "Graphic Design",
        description: "Professional branding solutions including logo design, visual identity systems, and marketing collateral development."
      },
      cloudDevops: {
        title: "Cloud & DevOps",
        description: "Cloud migration, infrastructure automation, continuous deployment pipelines, and scalable architecture solutions."
      },
      cybersecurity: {
        title: "Cybersecurity",
        description: "Comprehensive security services including penetration testing, compliance auditing, and real-time threat monitoring."
      },
      itSupport: {
        title: "Managed IT Services",
        description: "Proactive IT support with 24/7 monitoring, helpdesk services, and strategic technology planning."
      }
    }
  }
};
export const frServices = {
  services: {
    our:"NOS",
    title: "SERVICES",
    subTitle:"BOOSTEZ VOTRE ENTREPRISE AVEC NOTRE EXPERTISE NUMÉRIQUE!",
    description: "Ganesh Coding Office propose des services numériques innovants, du développement web et mobile à l'informatique en nuage, DevOps et la cybersécurité, permettant aux entreprises de croître en toute confiance.",
    verticals: {
      webDevelopment: {
        title: "Développement de Sites Web",
        description: "Sites web réactifs sur mesure avec des frameworks modernes, optimisés pour la performance, la sécurité et la visibilité sur les moteurs de recherche."
      },
      mobileApp: {
        title: "Développement d'Applications Mobiles",
        description: "Applications mobiles natives et multiplateformes avec un design UX/UI intuitif, des capacités hors ligne et une intégration backend transparente."
      },
      digitalTransformation: {
        title: "Consultation en Transformation Numérique",
        description: "Consultation en stratégie numérique de bout en bout pour moderniser les opérations, automatiser les processus et améliorer les expériences client."
      },
      seo: {
        title: "Optimisation SEO",
        description: "Stratégies SEO basées sur les données, y compris les audits techniques, l'optimisation du contenu et la création de liens pour maximiser la croissance organique."
      },
      socialMedia: {
        title: "Marketing des Réseaux Sociaux",
        description: "Gestion stratégique des réseaux sociaux avec création de contenu, publicité payante, partenariats avec des influenceurs et suivi des performances."
      },
      graphicDesign: {
        title: "Design Graphique",
        description: "Solutions de branding professionnelles, y compris la conception de logos, les systèmes d'identité visuelle et le développement de supports marketing."
      },
      cloudDevops: {
        title: "Cloud & DevOps",
        description: "Migration vers le cloud, automatisation de l'infrastructure, pipelines de déploiement continu et solutions d'architecture évolutives."
      },
      cybersecurity: {
        title: "Cybersécurité",
        description: "Services de sécurité complets, y compris les tests de pénétration, les audits de conformité et la surveillance des menaces en temps réel."
      },
      itSupport: {
        title: "Services IT Gérés",
        description: "Support IT proactif avec surveillance 24/7, services d'assistance et planification stratégique des technologies."
      }
    }
  }
};

export const nlServices = {
  services: {
    our: "ONZE",
    title: "DIENSTEN",
    subTitle: "VERSTERK UW BEDRIJF MET ONZE DIGITALE EXPERTISE!",
    description: "Ganesh Coding Office biedt innovatieve digitale diensten, van web- en app-ontwikkeling tot cloud computing, DevOps en cybersecurity, zodat bedrijven met vertrouwen kunnen groeien.",
    verticals: {
      webDevelopment: {
        title: "Webontwikkeling",
        description: "Maatwerk responsieve websites met moderne frameworks, geoptimaliseerd voor prestaties, beveiliging en zichtbaarheid in zoekmachines."
      },
      mobileApp: {
        title: "Mobiele App-ontwikkeling",
        description: "Native en cross-platform mobiele apps met intuïtief UX/UI-ontwerp, offline mogelijkheden en naadloze backend-integratie."
      },
      digitalTransformation: {
        title: "Digitale Transformatie Consultatie",
        description: "Eind-tot-eind digitale strategieconsultatie om operaties te moderniseren, processen te automatiseren en klantbelevingen te verbeteren."
      },
      seo: {
        title: "SEO Optimalisatie",
        description: "Data-gedreven SEO-strategieën, inclusief technische audits, contentoptimalisatie en linkbuilding om organische groei te maximaliseren."
      },
      socialMedia: {
        title: "Social Media Marketing",
        description: "Strategisch social media beheer met contentcreatie, betaalde advertenties, influencer-partnerschappen en prestatiemonitoring."
      },
      graphicDesign: {
        title: "Grafisch Ontwerp",
        description: "Professionele brandingoplossingen, inclusief logo-ontwerp, visuele identiteitssystemen en ontwikkeling van marketingmateriaal."
      },
      cloudDevops: {
        title: "Cloud & DevOps",
        description: "Cloudmigratie, infrastructuurautomatisering, continue implementatiepijplijnen en schaalbare architectuuroplossingen."
      },
      cybersecurity: {
        title: "Cybersecurity",
        description: "Uitgebreide beveiligingsdiensten, inclusief penetratietests, nalevingsaudits en realtime dreigingsmonitoring."
      },
      itSupport: {
        title: "Beheerde IT-diensten",
        description: "Proactieve IT-ondersteuning met 24/7 monitoring, helpdeskservices en strategische technologieplanning."
      }
    }
  }
};
export const deServices = {
  services: {
    our: "UNSERE",
    title: "DIENSTLEISTUNGEN",
    subTitle: "STÄRKEN SIE IHR UNTERNEHMEN MIT UNSERER DIGITALEN EXPERTISE!",
    description: "Ganesh Coding Office bietet innovative digitale Dienstleistungen, von Web- und App-Entwicklung bis hin zu Cloud-Computing, DevOps und Cybersicherheit, damit Unternehmen mit Vertrauen wachsen können.",
    verticals: {
      webDevelopment: {
        title: "Webentwicklung",
        description: "Maßgeschneiderte responsive Websites mit modernen Frameworks, optimiert für Leistung, Sicherheit und Sichtbarkeit in Suchmaschinen."
      },
      mobileApp: {
        title: "Mobile App-Entwicklung",
        description: "Native und plattformübergreifende mobile Apps mit intuitivem UX/UI-Design, Offline-Funktionen und nahtloser Backend-Integration."
      },
      digitalTransformation: {
        title: "Digitale Transformationsberatung",
        description: "End-to-End-Digitalstrategieberatung zur Modernisierung von Abläufen, Automatisierung von Prozessen und Verbesserung von Kundenerlebnissen."
      },
      seo: {
        title: "SEO-Optimierung",
        description: "Datengetriebene SEO-Strategien, einschließlich technischer Audits, Inhaltsoptimierung und Linkbuilding zur Maximierung des organischen Wachstums."
      },
      socialMedia: {
        title: "Social Media Marketing",
        description: "Strategisches Social Media Management mit Content-Erstellung, bezahlten Anzeigen, Influencer-Partnerschaften und Leistungsüberwachung."
      },
      graphicDesign: {
        title: "Grafikdesign",
        description: "Professionelle Branding-Lösungen, einschließlich Logo-Design, visueller Identitätssysteme und Entwicklung von Marketingmaterialien."
      },
      cloudDevops: {
        title: "Cloud & DevOps",
        description: "Cloud-Migration, Infrastrukturautomatisierung, kontinuierliche Bereitstellungspipelines und skalierbare Architekturlösungen."
      },
      cybersecurity: {
        title: "Cybersicherheit",
        description: "Umfassende Sicherheitsdienste, einschließlich Penetrationstests, Compliance-Audits und Echtzeit-Bedrohungsüberwachung."
      },
      itSupport: {
        title: "Managed IT Services",
        description: "Proaktive IT-Unterstützung mit 24/7-Überwachung, Helpdesk-Services und strategischer Technologieplanung."
      }
    }
  }
};